import React from 'react';
import './css/PartyUI2.css';
import { partyColors, MemoImage } from './ApiUtils';

const fontColor = '#a5a6aa', borderColor = '#a4a6aa';

const PartyUI2 = ({ partyItem, partyLogos, stateIndex, isMpMla, removeGroupParty }) => {

    let { partyId, mlaLeads, mpLeads } = partyItem;
    let partyLogo = partyLogos[partyId];
    const isIndia = stateIndex==0;
    const partyColor = partyColors[partyId];
    let { mla, mp } = isMpMla;

    return (
        <div style={{ paddingTop: 20, fontWeight: 'bold', color: fontColor, fontSize: 14, }}>
            <div className='partyLogo' style={{ display: 'flex', width: '100%', cursor: 'pointer' }}>
                <div className='partyLogo2' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', borderRadius: 54, padding: 16,
                    zIndex: 1, border: '2px solid #D5D6DD', backgroundColor: '#fff', width: 72, height: 72 }}>
                        {MemoImage(partyLogo, partyId)}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', borderRadius: 5, marginLeft: -10,
                    border: '2px solid #D5D6DD', backgroundColor: '#fff', width: 150 }}>
                        <div style={{ textAlign: 'center', padding: 8, border: '0px solid #D5D6DD',
                        backgroundColor: partyColor, color: '#fff',
                        borderBottomWidth: 2, paddingLeft: 20, paddingRight: 20, justifyContent: 'center' }}>
                        {partyId}
                        </div>
                        <div style={{ display: isIndia||(!mla) ? 'none' : 'flex', textAlign: 'center', padding: 8,
                        border: '0px solid #D5D6DD', borderBottomWidth: mp ? 2 : 0, paddingLeft: 20, paddingRight: 20,
                        justifyContent: 'center' }}>
                        MLA - {mlaLeads||0}
                        </div>
                        <div style={{ display: mp ? 'flex' : 'none', textAlign: 'center', padding: 8,
                        paddingLeft: 20, paddingRight: 20, justifyContent: 'center' }}>
                        MP - {mpLeads||0}
                        </div>
                    </div>
                </div>
                <div className='deleteImage' onClick={()=>{removeGroupParty()}}>
                    <img src={require('./assets/closeIcon.png')} width={'80px'} />
                </div>
            </div>
        </div>
    );
}

export default PartyUI2;